import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import {
  legalDocumentBodySx,
  legalDocumentCardSx,
  legalPageContainerSx,
  legalPageHeaderSx,
  legalPageMetaSx,
  legalPageShellSx,
  legalPageTitleSx,
} from "./styles";

const sectionTitleStyle = {
  color: "white",
  fontSize: "20px",
  lineHeight: 1.4,
  marginTop: "28px",
  marginBottom: "10px",
  fontWeight: 700,
};

const EnterpriseAddendum: React.FC = () => {
  useEffect(() => {
    document.title = "Enterprise Addendum - OmMuse";
  }, []);

  return (
    <Box sx={legalPageShellSx}>
      <Box sx={legalPageContainerSx}>
        <Box sx={legalPageHeaderSx}>
          <Typography sx={legalPageTitleSx}>
            OmMuse Enterprise Addendum
          </Typography>
          <Typography sx={legalPageMetaSx}>
            Effective Date: April 3, 2026
          </Typography>
        </Box>
        <Box sx={legalDocumentCardSx}>
          <Box sx={legalDocumentBodySx}>

      <p>
        This Enterprise Addendum supplements the OmMuse Terms of Use for
        enterprise customers, including labels, managers, agencies, and other
        organizations using OmMuse for team collaboration. If there is a
        conflict between this Addendum and the OmMuse Terms of Use, this
        Addendum controls for enterprise use.
      </p>

      <p style={sectionTitleStyle}>1. Scope of Services</p>
      <p>
        OmMuse provides enterprise collaboration tools for music and creative
        workflows, including project organization, file storage, controlled
        sharing, and permission-based team access.
      </p>

      <p style={sectionTitleStyle}>2. Data Ownership and Control</p>
      <p>
        Your organization retains ownership of the content you upload to
        OmMuse. OmMuse does not claim ownership of enterprise customer content.
        Your organization controls access permissions, collaborators, and
        sharing settings.
      </p>

      <p style={sectionTitleStyle}>3. Content Responsibility</p>
      <p>
        You represent that your organization owns or has the necessary rights
        to upload, store, and share all content placed on the platform. You
        must not upload or distribute content that infringes third-party rights
        or misrepresents ownership.
      </p>

      <p style={sectionTitleStyle}>4. Security and Data Handling</p>
      <p>
        OmMuse uses commercially reasonable safeguards, including secure cloud
        infrastructure, authentication controls, and encryption in transit and
        where applicable at rest. OmMuse may rely on service providers to help
        operate the platform.
      </p>

      <p style={sectionTitleStyle}>5. Confidentiality</p>
      <p>
        OmMuse will treat enterprise customer content as confidential except as
        needed to operate the platform, comply with law, or enforce our rights.
        Enterprise customers agree not to disclose OmMuse proprietary systems
        or technology.
      </p>

      <p style={sectionTitleStyle}>6. Platform Use Restrictions</p>
      <p>
        Enterprise customers may not reverse engineer, copy, recreate, or use
        OmMuse to build a competing product, and may not misuse platform data
        or workflows.
      </p>

      <p style={sectionTitleStyle}>7. Service Availability</p>
      <p>
        OmMuse will use commercially reasonable efforts to maintain service
        availability, but uninterrupted access is not guaranteed.
      </p>

      <p style={sectionTitleStyle}>8. Data Portability</p>
      <p>
        Subject to technical feasibility, enterprise customers may request
        export of their data before termination of service.
      </p>

      <p style={sectionTitleStyle}>9. Indemnification</p>
      <p>
        Enterprise customers agree to indemnify OmMuse for claims arising from
        uploaded content, intellectual property infringement, or unauthorized
        use of third-party materials.
      </p>

      <p style={sectionTitleStyle}>10. Limitation of Liability</p>
      <p>
        To the fullest extent permitted by law, OmMuse is not liable for
        indirect, incidental, special, or consequential damages. Liability is
        limited as described in the main OmMuse Terms of Use.
      </p>

      <p style={sectionTitleStyle}>11. Termination</p>
      <p>
        Upon termination, enterprise access may be revoked and data may be
        deleted after a reasonable retention period, subject to applicable law
        and operational requirements.
      </p>

      <p style={sectionTitleStyle}>12. Governing Terms</p>
      <p>
        This Addendum incorporates the OmMuse Terms of Use and Privacy Policy.
        Continued use of OmMuse as an enterprise member after acceptance of
        this Addendum constitutes agreement to those documents as updated from
        time to time.
      </p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EnterpriseAddendum;
